var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "inventory-item-actions",
      class: {
        "inventory-item-actions-yellow": _vm.record.status.desc === "notissued",
        "inventory-item-actions-red":
          _vm.record.status.desc === "issuedoverdue",
      },
    },
    [
      _vm.record.isShowIssuedMoreButton
        ? _c("c-button", {
            staticClass: "inventory-item-actions-give-more",
            attrs: { size: "small", label: "Выдать еще" },
            on: {
              click: function ($event) {
                _vm.isShowNewInventoryItemModal = true
              },
            },
          })
        : _vm._e(),
      _vm.record.status.desc === "notissued"
        ? _c("c-button", {
            staticClass: "inventory-item-actions-give",
            attrs: { size: "small", label: "Выдать" },
            on: {
              click: function ($event) {
                _vm.isShowNewInventoryItemModal = true
              },
            },
          })
        : _vm._e(),
      _vm.record.status.desc === "issued" ||
      _vm.record.status.desc === "issuedoverdue" ||
      _vm.record.status.desc === "hasalready"
        ? _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Удалить",
                  placement: "top",
                },
                expression:
                  "{ container: '#app', trigger: 'hover blur', content: 'Удалить', placement: 'top' }",
                modifiers: { html: true },
              },
            ],
            staticClass: "inventory-item-actions-trash",
            class: {
              "inventory-item-actions-trash-margin":
                _vm.record.status.desc === "issuedoverdue" ||
                _vm.record.status.desc === "hasalready",
            },
            attrs: { size: "iconic", icon: "trash" },
            on: {
              click: function ($event) {
                return _vm.removeInventoryItem()
              },
            },
          })
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: {
            id: "inventory-items-actions-new-item-modal",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          on: { show: _vm.onShowModal },
          model: {
            value: _vm.isShowNewInventoryItemModal,
            callback: function ($$v) {
              _vm.isShowNewInventoryItemModal = $$v
            },
            expression: "isShowNewInventoryItemModal",
          },
        },
        [
          _c("div", { staticClass: "inventory-items-actions-modal" }, [
            _c(
              "svg",
              {
                staticClass: "inventory-item-actions-modal-close",
                attrs: {
                  width: "15",
                  height: "16",
                  viewBox: "0 0 15 16",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
                on: {
                  click: function ($event) {
                    _vm.isShowNewInventoryItemModal = false
                  },
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                    fill: "#8E9CBB",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                    fill: "#8E9CBB",
                  },
                }),
              ]
            ),
            _c("div", { staticClass: "inventory-item-actions-modal-title" }, [
              _vm._v(" " + _vm._s(_vm.record.position.value) + " "),
            ]),
            _c(
              "div",
              {
                staticClass: "inventory-item-actions-modal-inputs",
                class: {
                  "inventory-item-actions-modal-inputs-required":
                    _vm.dateIssuingLocalErrorMessage.length > 0,
                },
              },
              [
                _c("c-input", {
                  ref: "inventoryActionsDateNewIssue",
                  staticClass: "inventory-item-actions-modal-inputs-date",
                  attrs: {
                    label: "Дата выдачи",
                    type: "date",
                    format: "DD.MM.YYYY, dddd",
                    editable: true,
                    icon: "calendar",
                    placeholder: "00.00.0000",
                    required: _vm.dateIssuingLocalErrorMessage,
                    "icon-right": true,
                  },
                  on: { invalidDate: _vm.sendErrorDateMessage },
                  model: {
                    value: _vm.dateIssuingLocal,
                    callback: function ($$v) {
                      _vm.dateIssuingLocal = $$v
                    },
                    expression: "dateIssuingLocal",
                  },
                }),
                _c("c-input", {
                  staticClass: "inventory-item-actions-modal-inputs-select",
                  attrs: {
                    items: _vm.whoIssuingItems,
                    type: "select",
                    required: _vm.whoIssuedLocalErrorMessage,
                    "required-condition":
                      _vm.whoIssuedLocalErrorMessage.length > 0,
                    searchable: true,
                    label: "Кто выдал",
                    placeholder: "Выберите значение",
                  },
                  model: {
                    value: _vm.whoIssuedLocal,
                    callback: function ($$v) {
                      _vm.whoIssuedLocal = $$v
                    },
                    expression: "whoIssuedLocal",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "inventory-item-actions-modal-buttons" },
              [
                _c("c-button", {
                  staticClass: "inventory-item-actions-modal-buttons-cancel",
                  attrs: { label: "Отменить" },
                  on: {
                    click: function ($event) {
                      _vm.isShowNewInventoryItemModal = false
                    },
                  },
                }),
                _c("c-button", {
                  staticClass: "inventory-item-actions-modal-buttons-save",
                  attrs: { label: "Сохранить", color: "primary" },
                  on: { click: _vm.issueInventory },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }